// The header Items widget's "Copy all tracking links for the order"
// (2026-10-12). Pure, so it is unit-testable.
//
// Every UNIQUE tracking link of the PARENT order, in first-seen order, across
// every item the order has (not just the rows the compact widget shows),
// kit/component rows included (groupItemsForTable() lists components as their
// own rows; a nested components/children list is walked too). Replacement-
// order tracking (source other than 'parent') and an entry with no url are
// skipped.
export function parentOrderTrackingLinks(items) {
  const seen = new Set()
  const links = []
  const visit = (item) => {
    for (const t of item?.tracking ?? []) {
      if (t?.source !== 'parent') continue
      const url = String(t?.url ?? '').trim()
      if (!url || seen.has(url)) continue
      seen.add(url)
      links.push(url)
    }
    for (const child of item?.components ?? item?.children ?? []) visit(child)
  }
  for (const item of items ?? []) visit(item)
  return links
}

// What the copy puts on the clipboard: one link per line, so they paste one
// per line.
export function trackingLinksClipboardText(links) {
  return (links ?? []).join('\n')
}

// One Return Label(s) line in the order header (2026-10-23): "<number>
// (<carrier>)" for our label, and "<number> (USPS) · customer's own label"
// for a tracking number the customer gave us (source 'customer', read from
// their photo). The carrier is the internal code, as TRQ writes it, with
// the Amazon carrier as ATS (internal, 2026-10-23).
export function returnLabelText(t) {
  const carrier = t?.carrier ? String(t.carrier).replace(/^AMZ$/i, 'ATS') : null
  const base = `${t?.trackingNumber ?? ''}${carrier ? ` (${carrier})` : ''}`
  return t?.source === 'customer' ? `${base} · customer's own label` : base
}
